<template>
  <div>
    <div v-if="this.kontaktiert">
      <v-layout
        row
        wrap
      >

        <v-flex xs12 sm3 md3 lg3 >
          <v-icon left>contact_phone</v-icon>
          <span class="subheading">
            Kontaktdaten
          </span>
        </v-flex>
        <v-flex class="subheading grey lighten-5 pa-1">
          <v-layout row wrap>
            <v-flex xs2>
              Name:
            </v-flex>
            <v-flex>{{ anfrage.name }}</v-flex>
          </v-layout>

          <v-layout
            row wrap
            v-if="anfrage.telefon"
          >
            <v-flex xs2>
              Telefon:
            </v-flex>
            <v-flex>{{ anfrage.telefon }}</v-flex>
          </v-layout>
          <v-layout
            row wrap
            v-if="anfrage.email"
          >
            <v-flex xs2>
              E-Mail:
            </v-flex>
            <v-flex>{{ anfrage.email }}</v-flex>
          </v-layout>

        </v-flex>
      </v-layout>
    </div>
    <div v-else>

      <v-layout
        row
        wrap
      >

        <v-flex xs3>
          <v-icon left>contact_phone</v-icon>
          <span class="subheading">
            Kontaktdaten
          </span>
        </v-flex>
        <v-flex class="subheading pa-1">
          <v-btn
            @click="zeigeKontakt()"
            color="accent"
          >Kunden Kontakt anzeigen</v-btn>

        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  components: {},
  data () {
    return {
      showcontact: false
    }
  },
  props: ['anfrage'],
  methods: {
    zeigeKontakt: function () {
      console.log('zeigekontakt')
      const app = this
      var id = this.anfrage.hashid
      axios
        .post('/api/v1/anfragekontakt/' + id)
        .then(function (resp) {
          // console.log(resp)
          app.showcontact = true
        })
        .catch(function (error) {
          console.log(error)
        })
      this.showcontact = true
    }
  },
  computed: {
    kontaktiert: function () {
      if (this.anfrage.bereitskontaktiert[0]) {
        return true
      } else if (this.showcontact) {
        return true
      } else return false
    }
  }
}
</script>